import { createContext, useEffect, useReducer } from "react";
import auth from "./reducers/auth";
import pendiente from "./reducers/pendiente";
import historico from "./reducers/historico";
import authInitialState from "./initialStates/authInitialState";
import pendienteInitialState from "./initialStates/pendienteInitialState";
import historicoInitialState from "./initialStates/historicoInitialState";

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [authState, authDispatch] = useReducer(auth, [], () => {
    const localData = sessionStorage.auth;
    return localData ? JSON.parse(localData): authInitialState;
  });
  const [pendienteState, pendienteDispatch] = useReducer(
    pendiente,
    pendienteInitialState
  );
  const [historicoState, historicoDispatch] = useReducer(
    historico,
    historicoInitialState
  );

  useEffect(() => {
    sessionStorage.auth = JSON.stringify(authState);
  }, [authState]);

  return (
    <GlobalContext.Provider
      value={{
        authState,
        authDispatch,
        pendienteState,
        pendienteDispatch,
        historicoState,
        historicoDispatch,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
